import wixMediaCanvas from './WixMediaCanvas';
const ELEMENT_NAME = 'wix-media-canvas';
export function init(contextWindow, services) {
  contextWindow = contextWindow || window;
  if (contextWindow.customElements.get(ELEMENT_NAME)) {
    return;
  }
  let intersectionObserver;
  if (contextWindow.IntersectionObserver) {
    intersectionObserver = new IntersectionObserver(entries => entries.forEach(entry => {
      const wixMediaCanvasEl = entry.target;
      if (entry.isIntersecting) {
        wixMediaCanvasEl.show();
      } else {
        wixMediaCanvasEl.hide();
      }
    }));
  }
  let resizeObserver;
  if (contextWindow.ResizeObserver) {
    resizeObserver = new ResizeObserver(entries => {
      entries.forEach(entry => {
        var _entry$contentBoxSize;
        const wixMediaCanvasEl = entry.target;
        if ((_entry$contentBoxSize = entry.contentBoxSize) != null && (_entry$contentBoxSize = _entry$contentBoxSize[0]) != null && _entry$contentBoxSize.inlineSize && entry.contentBoxSize[0].blockSize) {
          var _entry$contentBoxSize2;
          wixMediaCanvasEl.resize((_entry$contentBoxSize2 = entry.contentBoxSize) == null || (_entry$contentBoxSize2 = _entry$contentBoxSize2[0]) == null ? void 0 : _entry$contentBoxSize2.inlineSize, entry.contentBoxSize[0].blockSize);
        }
      });
    });
  }
  return function () {
    const WixMediaCanvas = wixMediaCanvas({
      ...services,
      intersectionService: intersectionObserver,
      resizeService: resizeObserver
    }, contextWindow);
    contextWindow.customElements.define(ELEMENT_NAME, WixMediaCanvas);
  };
}
//# sourceMappingURL=registry.js.map